var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "fcl-search-bar",
            {
              attrs: {
                "show-currency": false,
                "is-manage-module": true,
                "show-schedule": false,
                filter: _vm.filter,
                source: "PriceFCLExtra",
                "source-show-level": false,
                "config-id": "PriceFCLExtra"
              },
              on: {
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery,
                reset: _vm.resetQuery
              }
            },
            [
              _vm.isCp
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _vm.inputAllowed_PP
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "onEditCP",
                                type: "primary",
                                disabled:
                                  !this.cpSelectRow || _vm.selectedCpCount > 1
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onEdit_CP()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                          )
                        : _vm._e(),
                      _vm.deleteAllowed_CP
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "onDeleteCP",
                                type: "danger",
                                disabled: !_vm.selectedCpCount
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onDelete_CP()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeTabName === "ppList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _vm.inputAllowed_PP
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "onEditPP",
                                type: "primary",
                                disabled:
                                  !this.ppSelectRow || _vm.selectedPpCount > 1
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onEdit_PP()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "onDeletePP",
                            type: "danger",
                            disabled: !_vm.selectedPpCount
                          },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      ),
                      _vm.approveAllowed_PP
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "onApprovePP", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.onApprove_PP()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Approve")))]
                          )
                        : _vm._e(),
                      _vm.inputAllowed_PP
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "onAddPP", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.onAdd_PP()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                          )
                        : _vm._e(),
                      _vm.inputAllowed_PP
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "onDownloadTemplate",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onDownloadTemplate()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Template")))]
                          )
                        : _vm._e(),
                      _vm.inputAllowed_PP
                        ? _c(
                            "el-upload",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "5px"
                              },
                              attrs: {
                                no: "saveExcelFile",
                                action:
                                  _vm.URL.price.priceFclExtra.saveExcelFile,
                                headers: { sessionId: _vm.sessionId },
                                "show-file-list": false,
                                accept: ".xls, .xlsx",
                                "on-success": _vm.uploadExcelSuccess,
                                data: _vm.officeId
                              }
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { no: "import", type: "primary" } },
                                [_vm._v(_vm._s(_vm.$t("Pricing.Import")))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              ref: "tabs",
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.CurrentPrice"),
                    name: "cpList"
                  }
                },
                [
                  _c("fcl-extra-data-grid", {
                    attrs: {
                      "v-if": _vm.isCp,
                      source: "priceFCLExtra",
                      "config-module": "220601",
                      "row-data": _vm.rowCpData,
                      "show-approve": true,
                      "show-branch": false,
                      filter: _vm.filter,
                      "grid-options": _vm.cpGridOptions,
                      "show-check-box": true
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.PendingPrice"),
                    name: "ppList"
                  }
                },
                [
                  _c("fcl-extra-data-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "ppList",
                      source: "priceFCLExtra",
                      "config-module": "220602",
                      "row-data": _vm.rowPpData,
                      "show-approve": false,
                      "show-branch": false,
                      filter: _vm.filter,
                      "grid-options": _vm.ppGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("fcl-extra-form", {
        attrs: {
          visible: _vm.fclExtraFormDialog.visible,
          price: _vm.fclExtraFormDialog.price,
          "is-new": _vm.fclExtraFormDialog.isNew,
          "is-cp": _vm.isCp
        },
        on: { close: _vm.onFclFormDialogClose, reload: _vm.toQuery }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }